export default "__VITE_ASSET__CZutp0pw__"